import api from './api';

/**
 * Service para gerenciamento de contatos de produção
 */

export const productionContactsService = {
  // Listar contatos de um projeto
  getContacts: (projectId) => api.get(`/projects/${projectId}/production-contacts`),

  // Criar novo contato
  createContact: (projectId, data) => api.post(`/projects/${projectId}/production-contacts`, data),

  // Atualizar contato
  updateContact: (contactId, data) => api.put(`/production-contacts/${contactId}`, data),

  // Deletar contato
  deleteContact: (contactId) => api.delete(`/production-contacts/${contactId}`),

  // Buscar próximo contato pendente
  getNextPendingContact: (projectId) => api.get(`/projects/${projectId}/production-contacts/next`)
};

export default productionContactsService;